import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExclamationCircleFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#faad14",
		d: "M12 1.5C6.202 1.5 1.5 6.202 1.5 12S6.202 22.5 12 22.5 22.5 17.798 22.5 12 17.798 1.5 12 1.5m-.75 5.438c0-.104.084-.188.188-.188h1.124c.104 0 .188.084.188.188v6.375a.19.19 0 0 1-.187.187h-1.126a.19.19 0 0 1-.187-.187zM12 17.25A1.125 1.125 0 0 1 12 15a1.125 1.125 0 0 1 0 2.25"
	})
});
export default SvgExclamationCircleFilled;
